module.exports = __webpack_public_path__ + "img/reward-top-bg-ug.10b5367e.png";